import { getRecruitmentCampaignCategories as getRecruitmentCampaignCategoriesApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetRecruitmentCampaignCategoriesServiceResponse } from './get-recruitment-categories.dto';
import { GetRecruitmentCampaignCategoriesServiceResponseSchema } from './get-recruitment-categories.dto';

export const getRecruitmentCampaignCategoriesService = withServiceErrorCapture(
  lazyPipe(async (): Promise<GetRecruitmentCampaignCategoriesServiceResponse> => {
    const apiResponse = await getRecruitmentCampaignCategoriesApi();

    if (apiResponse.meta?.result === 'FAIL') {
      throw new Error(apiResponse.meta?.message ?? '카테고리 조회에 실패했습니다.');
    }
    return apiResponse.data;
  }, validateServiceResponse(GetRecruitmentCampaignCategoriesServiceResponseSchema)),
);
